<template>
    <v-toolbar
            dense
            fixed
            dark
            clipped-left
            app
            :color="toolbarColour"
    >
        <v-toolbar-side-icon @click.stop="raiseNavToggle"></v-toolbar-side-icon>
        <v-toolbar-title class="mr-5 align-center" @click="$router.push({name: 'default'})" style="cursor: pointer;">
            {{systemConfig.vuetify.siteTitle}}&nbsp;<span class="font-weight-light">{{systemConfig.vuetify.siteSubTitle}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <user-toolbar-actions :firebaseUser="firebaseUser" :user="user"
                              :systemConfig="systemConfig"></user-toolbar-actions>
    </v-toolbar>
</template>

<script>
  import UserToolbarActions from '@/views/app/elements/UserToolbarActions'

  export default {
    name: 'Toolbar',
    components: {UserToolbarActions},
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      drawer: true
    }),
    computed: {
      toolbarColour () {
        if (this.systemConfig.hasOwnProperty('vuetify') && this.systemConfig.vuetify.hasOwnProperty('toolbarColour')) {
          return this.systemConfig.vuetify.toolbarColour
        }
        return null
      }
    },
    methods: {
      raiseNavToggle () {
        console.log('Emitting nav toggle')
        this.$emit('toggleNav')
      }
    }
  }
</script>

<style scoped>

</style>
